import styled, { css } from 'styled-components';
import { spacing } from '@ardoq/design-tokens';
import { ModalSize } from '../types';
import { BUTTON_SELECTOR } from '@ardoq/button';
import { Box } from '@ardoq/layout';

export const ButtonContainer = styled.div<{
  $modalSize: ModalSize;
}>`
  display: flex;
  flex-direction: row;
  gap: ${spacing.s8};
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  ${({ $modalSize }) =>
    ModalSize.XS === $modalSize &&
    css`
      flex-direction: column;
      align-items: initial;
      ${BUTTON_SELECTOR} {
        display: flex;
        justify-content: center;
      }
    `};
`;

export const DoqWrapper = styled.div`
  align-self: center;
`;

export const ModalLayout = styled(Box).attrs({
  paddingX: 'large',
  paddingTop: 'medium',
})`
  display: flex;
  flex-direction: column;
  gap: ${spacing.s16};
  &:last-child {
    padding-bottom: ${spacing.s24};
  }
`;
